import { getEntity } from "utils/entities";
import { ProjectSchema } from "utils/schemas";

export const getProjectToEdit = getEntity(
  (state) => state.project.edit.projectToEdit,
  ProjectSchema
);
